export default {
  USER: { 
    permissions: [], 
    config: { 
    } 
  },
  ajaxCallsInProgress: 0
};



// WEBPACK FOOTER //
// ./src/configurations/initialValues.js